module.exports = __webpack_public_path__ + "img/U_skill_bar.263937ff.png";